
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/device-item/[slug]",
      function () {
        return require("private-next-pages/device-item/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/device-item/[slug]"])
      });
    }
  